(function ($, Global) {
    function OfferModel() {
        // Déclaration class objet
    }

	OfferModel.prototype.register = function (data, $form, callback) {
		$.ajaxPost('/ajax/offre/create', data)
			.done(function (result) {
				Global.ajaxCallback({
					results: result,
					form: $form,
					success: callback
				});
			});
	}

	OfferModel.prototype.login = function (data, $form, callback) {
		$.ajaxPost('/ajax/offre/login', data)
			.done(function (result) {
				Global.ajaxCallback({
					results: result,
					form: $form,
					success: callback
				});
			});
	}

	OfferModel.prototype.activate = function (data, $form, callback) {
		$.ajaxPost('/ajax/offre/activate', data)
			.done(function (result) {
				Global.ajaxCallback({
					results: result,
					form: $form,
					success: callback
				});
			});
	}

	Global.OfferModel = OfferModel;
}(jQuery, window));